import { useState, useMemo } from "react";
import SelectStaff from "components/elements/selectStaff";
import SelectShop from "components/elements/selectShop";
import DatetimePicker from "components/elements/dateTimePicker";
import {
    getAnalyticOrderProduct,
    getAnalyticOrderProductCrawl,
    getAnalyticOrder,
    getAnalyticOrderShop,
    getAnalyticOrderShipping,
} from "actions/analyticActions";
import { connect } from "react-redux";
import useCallApi from "hook/useCallApi";
import useCallApiUrl from "hook/useCallApiUrl";
import Loading from "components/Loading";
import { formatterCreateAt, permissionComponent } from "components/Function";
import TableProduct from "./tableProduct";
import ChartProductCrawl from "./chartProductCrawl";
import OrderTotal from "./orderTotal";
import ShopData from "./shopData";
import TablePrinter from "./tablePrinter";

const OrderAnalytic = ({
    formatterCreateAt,
    getAnalyticOrderProduct,
    getAnalyticOrderProductCrawl,
    getAnalyticOrder,
    getAnalyticOrderShop,
    getAnalyticOrderShipping,
    user,
}) => {
    const [filter, setFilter] = useState({});
    const [tablePaginate, setTablePaginate] = useState({
        offset: 0,
        limit: 10,
    });
    const searchOptions = useMemo(() => {
        return { filter };
    }, [filter]);
    const searchOptionsTopCancel = useMemo(() => {
        return { filter: { ...filter, status: "CANCELLED" } };
    }, [filter]);
    const searchOptionsTopReturn = useMemo(() => {
        return { filter: { ...filter, status: "RETURN" } };
    }, [filter]);
    const searchOptionsOrderShop = useMemo(() => {
        return { filter: { ...filter, ...tablePaginate } };
    }, [filter, tablePaginate]);

    const { data: productTopSale, loading } = useCallApi(
        getAnalyticOrderProduct,
        searchOptions,
        Object.keys(filter).length > 0
    );
    const { data: productTopCancel, loading: topCancelLoading } = useCallApi(
        getAnalyticOrderProduct,
        searchOptionsTopCancel,
        Object.keys(filter).length > 0
    );
    const { data: productTopReturn, loading: topReturnLoading } = useCallApi(
        getAnalyticOrderProduct,
        searchOptionsTopReturn,
        Object.keys(filter).length > 0
    );
    const { data: productCrawl, loading: loadingProductCrawl } = useCallApi(
        getAnalyticOrderProductCrawl,
        searchOptions,
        Object.keys(filter).length > 0
    );
    const { data: orderAnalytic, loading: loadingOrderAnalytic } = useCallApi(
        getAnalyticOrder,
        searchOptions,
        Object.keys(filter).length > 0
    );
    const { data: orderShopAnalytic, loading: loadingOrderShopAnalytic } = useCallApi(
        getAnalyticOrderShop,
        searchOptionsOrderShop,
        Object.keys(filter).length > 0
    );
    const { data: orderPrinter, loading: loadingOrderPrinter } = useCallApiUrl(
        "/api/analytic/order/printer",
        filter,
        Object.keys(filter).length > 0 && user?.user?.role === 1
    );

    const { data: orderShipping, loading: loadingOrderShipping } = useCallApi(
        getAnalyticOrderShipping,
    );
    
    const handleTableChange = ({ page, limit }) => {
        setTablePaginate((prev) => ({ ...prev, offset: page - 1 ?? prev.page, limit: limit ?? prev.limit }));
    };

    return (
        <div className="d-flex flex-column gap-6" style={{ maxWidth: "1780px", margin: "auto" }}>
            <Loading
                isLoading={
                    loading ||
                    topCancelLoading ||
                    topReturnLoading ||
                    loadingProductCrawl ||
                    loadingOrderAnalytic ||
                    loadingOrderShopAnalytic ||
                    loadingOrderPrinter ||
                    loadingOrderShipping
                }
            />
            <div className="row">
                <h4>Shipment Data: {orderShipping?.totalCount || 0} Orders</h4>
                <div className="col-md-2 bg-warning text-black d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Wait Shipment"}
                    </div>
                    <div className="fs-2 fw-bold counted">{orderShipping?.awaitingShipmentCount || 0}</div>
                </div>
                <div className="col-md-2 bg-info text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Wait Collection"}
                    </div>
                    <div className="fs-2 fw-bold counted">{orderShipping?.awaitingCollectionCount || 0}</div>
                </div>
                <div className="col-md-2 bg-primary text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8">
                    <div className="fw-semibold fs-6 mb-3">
                        {"In Transit"}
                    </div>
                    <div className="fs-2 fw-bold counted">{orderShipping?.inTransitCount || 0}</div>
                </div>
                <div className="col-md-2 bg-success text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Delivered"}
                    </div>
                    <div className="fs-2 fw-bold counted">{orderShipping?.deliveredCount || 0}</div>
                </div>
                <div className="col-md-2 bg-dark text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Completed"}
                    </div>
                    <div className="fs-2 fw-bold counted">{orderShipping?.completedCount || 0}</div>
                </div>
                <div className="col-md-2 bg-danger text-white d-flex flex-column justify-content-center align-items-center text-center py-10 px-6 bg-opacity-75 al-border-radius-8">
                    <div className="fw-semibold fs-6 mb-3">
                        {"Cancelled"}
                    </div>
                    <div className="fs-2 fw-bold counted">{orderShipping?.cancelledCount || 0}</div>
                </div>
            </div>
            <div className="d-flex gap-2 mb-4">
                <DatetimePicker
                    onChange={(data) => setFilter((prev) => ({ ...prev, ...data }))}
                    typeDefault="last_week"
                />
                <SelectStaff onChange={(data) => setFilter((prev) => ({ ...prev, staff: data }))} />
                <SelectShop onChange={(data) => setFilter((prev) => ({ ...prev, shopId: data }))} />
            </div>
            <div className="card card-body">
                <div className="row">
                    <div className="col-md-4">
                        <h4>Top Sale</h4>
                        <TableProduct data={productTopSale?.data || []} tableName="analyticOrderProductTopSale" />
                    </div>
                    <div className="col-md-4">
                        <h4>Top Cancel</h4>
                        <TableProduct data={productTopCancel?.data || []} tableName="analyticOrderProductTopCancel" />
                    </div>
                    <div className="col-md-4">
                        <h4>Top Return</h4>
                        <TableProduct data={productTopReturn?.data || []} tableName="analyticOrderProductTopReturn" />
                    </div>
                </div>
            </div>
            <div className="card card-body">
                <div className="row">
                    <div className="col-md-6 d-flex flex-column">
                        <h4 className="mb-8">Top Sale by Source</h4>
                        <div className="w-full d-flex  justify-content-center align-items-center">
                            <ChartProductCrawl data={productCrawl?.data || []} />
                        </div>
                    </div>
                    {permissionComponent({
                        user: user.user,
                        permission: "USER_REAL",
                        component: (
                            <div className="col-md-6 d-flex flex-column">
                                <h4 className="mb-8">Top Sale by Printer</h4>
                                <TablePrinter data={orderPrinter?.data || []} tableName="analyticOrderPrinter" />
                            </div>
                        ),
                        type: "component",
                    })}
                </div>
            </div>
            <div className="card card-body">
                <OrderTotal data={orderAnalytic?.data || []} />
            </div>
            <div className="card card-body">
                <div className="card card-body">
                    <ShopData
                        data={orderShopAnalytic?.data || []}
                        totalSize={orderShopAnalytic?.total || 0}
                        onTableChange={handleTableChange}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = {
    formatterCreateAt,
    getAnalyticOrderProduct,
    getAnalyticOrderProductCrawl,
    getAnalyticOrder,
    getAnalyticOrderShop,
    getAnalyticOrderShipping,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderAnalytic);
